module.exports = __webpack_public_path__ + "img/white_paper16.ca632ce5.png";